export default __webpack_public_path__ + "static/media/Heaven's Do Kki.dbe8b9d6.jpg";